class BrandTabsSection extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.tabs = this.querySelectorAll('.brand-tabs__tab');
    this.panels = this.querySelectorAll('.brand-tabs__panel');
    this.defaultTab = this.dataset.defaultTab;

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onTabKeydown.bind(this));
    });

    this.activateTab(this.defaultTab, false);
    this.updatePanelHeight();
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    this.activateTab(tab.dataset.tab, true);
  }

  onTabKeydown(event) {
    const tabs = Array.prototype.slice.call(this.tabs);
    const currentIndex = tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    switch (event.key) {
      case 'ArrowLeft':
        nextIndex = currentIndex <= 0 ? tabs.length - 1 : currentIndex - 1;
        break;
      case 'ArrowRight':
        nextIndex = currentIndex >= tabs.length - 1 ? 0 : currentIndex + 1;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activateTab(tabs[nextIndex].dataset.tab, true);
    tabs[nextIndex].focus();
  }

  activateTab(tabId, animate) {
    const panelsWrapper = this.querySelector('.brand-tabs__panels');
    let incomingPanel = null;
    const outgoingPanel = this.querySelector('.brand-tabs__panel.is-active');

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === tabId;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      if (panel.dataset.panel === tabId) {
        incomingPanel = panel;
      }
    });

    if (!incomingPanel || (outgoingPanel === incomingPanel && incomingPanel.classList.contains('is-active'))) {
      return;
    }

    incomingPanel.removeAttribute('hidden');

    if (animate) {
      incomingPanel.classList.add('is-active');
      if (outgoingPanel) {
        outgoingPanel.classList.remove('is-active');
        window.setTimeout(() => {
          if (!outgoingPanel.classList.contains('is-active')) {
            outgoingPanel.setAttribute('hidden', '');
          }
        }, 350);
      }
    } else {
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panel === tabId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    if (panelsWrapper && incomingPanel) {
      window.requestAnimationFrame(() => {
        this.updatePanelHeight();
      });
    }
  }

  updatePanelHeight() {
    const panelsWrapper = this.querySelector('.brand-tabs__panels');
    const activePanel = this.querySelector('.brand-tabs__panel.is-active');

    if (panelsWrapper && activePanel) {
      panelsWrapper.style.minHeight = activePanel.offsetHeight + 'px';
    }
  }
}

if (!customElements.get('brand-tabs-section')) {
  customElements.define('brand-tabs-section', BrandTabsSection);
}
